module.exports = __webpack_public_path__ + "static/media/product-step.6619f66d.png";